(function () {
    const selectors = {
        section: ".js-testimonials",
        slider: ".js-testimonials-slider"
    };

    function init() {
        const sections = document.querySelectorAll(selectors.section);

        sections.forEach(section => {
            initSlider(section);
        });
    }

    function initSlider(section) {
        const slider = section.querySelector(selectors.slider);

        if (!slider) return;

        if ($(slider).hasClass("slick-initialized")) {
            $(slider).slick("unslick");
        }

        $(slider).slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        if (typeof jQuery !== "undefined") {
            init();
        } else {
            console.error("jQuery not found!");
        }
    });

    document.addEventListener("shopify:section:load", function (event) {
        if (event.target.querySelector(selectors.section)) {
            initSlider(event.target.querySelector(selectors.section));
        }
    });

    document.addEventListener("shopify:section:unload", function (event) {
        const slider = event.target.querySelector(selectors.slider);
        if (slider && $(slider).hasClass("slick-initialized")) {
            $(slider).slick("unslick");
        }
    });
})();
